<template>
  <a-select
    :value="value"
    @change="change"
    class="ant-select-custom"
  >
    <aha-icon slot="suffixIcon" name="chevron-down-new" />
    <a-select-option
      v-for="option in options"
      :key="option.id"
      :value="option.id"
    >
      <div class="ant-select-custom-item">
        <div class="title">
          {{ option.title }}
        </div>
        <div class="flex gap-1">
          <span
            v-for="num in 5"
            :key="num"
            :style="{backgroundColor: `${option.colors[num]}`}"
            class="w-6 h-6 inline-block rounded-full"
          />
        </div>
      </div>
    </a-select-option>
  </a-select>
</template>

<script>

export default {
  name: 'AntdSelectMultiColor',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    change: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style scoped lang="scss">
.ant-select-custom {
  ::v-deep {
    .ant-select-dropdown-menu-item {
      color: red;
    }
    .ant-select-selection {
      border-radius: 8px;
      height: 100%;
    }
    .ant-select-selection__rendered {
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 12px;
      margin-right: 24px;
    }
    .ant-select-arrow {
      right: 8px;
      color: #282E3E;
    }
  }
}
</style>

<style lang="scss">
.ant-select-custom-item {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 0;
}
.ant-select-dropdown-content {
  .ant-select-dropdown-menu {
    padding: 4px;
  }
  .ant-select-dropdown-menu-item {
    border-radius: 4px;
  }
  .ant-select-dropdown-menu-item-selected {
    background-color: #D8E9FD;
  }
  .ant-select-dropdown-menu-item-active:hover:not(.ant-select-dropdown-menu-item-disabled) {
    background-color: #E6E6E6;
  }
}
</style>
